/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { validate as validateJson } from 'json-schema';

import { PgConfigValueWithUnit } from '../schema/pg-config.consts';
import { schema } from '../schema/pg-config.schema';
import { Config } from '../schema/pg-config.types';
import { deserialize } from '../serde/pg-config.deserialize';
import { serialize } from '../serde/pg-config.serialize';

export const normalize = (config: Config, renderedSchema: typeof schema): Config => {
  const validation = validateJson(config, renderedSchema);

  const serialized = serialize(config);

  if (!validation.valid) {
    // context.logger.debug('Found invalid formData', validation);
    validation.errors.forEach(error => {
      if (
        error.message.includes('must have a maximum value of') ||
        error.message.includes('must have a minimum value of')
      ) {
        const key = error.property.split('.').pop();
        if (key) {
          const value = serialized[key]!;
          let newValue: number | string = error.message.split(' ').pop() ?? '';
          if (PgConfigValueWithUnit.test(value)) {
            newValue += PgConfigValueWithUnit.exec(value)![2];
          } else {
            newValue = Number(newValue);
          }
          serialized[key] = newValue.toString();
        }
      }
    });
  }

  return deserialize(serialized, renderedSchema);
};
